import { capitalize } from "@/helpers/stringHelpers"
import { IStatus } from "@/types/Status"
import { Dayjs } from "dayjs"
export interface IIhdDetails {
  deviceId: string
  deviceType: string
  deviceTypeName: string
  dateInstalled?: Dayjs
  installedBy: string
  deviceStatus: IhdStatus | null
  dateCommissioned?: Dayjs
  responsiveStatus: string
  manufacturerCode: string
  manufacturerFullName: string
  manufacturerName: string
  model: string
  modelName: string
  smetsVersion: string
  firmwareVersion: string
  firmwareStatus: string
  mpan: string
  mprn: string
  elecSsd?: Dayjs
  gasSsd?: Dayjs
  dateLastUpdated?: Dayjs
  readonly ihdStatusType: IStatus
}

export enum IhdStatus {
  COMMISSIONED = "COMMISSIONED",
  DECOMMISSIONED = "DECOMMISSIONED",
  PENDING = "PENDING",
  INSTALLED_NOT_COMMISSIONED = "INSTALLED_NOT_COMMISSIONED",
  WHITELISTED = "WHITELISTED",
  UNKNOWN = "UNKNOWN",
  NO_IHD = "NO_IHD",
}

export const ihdStatuses: Record<IhdStatus, IStatus> = {
  [IhdStatus.COMMISSIONED]: {
    type: "normal",
    text: capitalize(IhdStatus.COMMISSIONED),
  },
  [IhdStatus.DECOMMISSIONED]: {
    type: "default",
    text: capitalize(IhdStatus.DECOMMISSIONED),
  },
  [IhdStatus.PENDING]: {
    type: "neutral",
    text: capitalize(IhdStatus.PENDING),
  },
  [IhdStatus.INSTALLED_NOT_COMMISSIONED]: {
    type: "critical",
    text: "Uncommissioned",
  },
  [IhdStatus.WHITELISTED]: {
    type: "neutral",
    text: "Allowlisted",
  },
  [IhdStatus.UNKNOWN]: {
    type: "critical",
    text: capitalize(IhdStatus.UNKNOWN),
  },
  [IhdStatus.NO_IHD]: {
    type: "caution",
    text: "No IHD found",
  },
}
